import React, { Children, useEffect, useState } from 'react';
import DownloadManager from '../utils/DownloadManager';
import { logError } from '@/utils/logHandling';

export function OfflineWrapper({ children, url }) {
  const [localUrl, setLocalUrl] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const localUri = await DownloadManager.getFileUri(url);
        setLocalUrl(localUri);
      } catch (error) {
        logError('Could not download file', error);
        setLocalUrl(url);
      }
    })();
  }, [url]);

  if (!localUrl) return;

  const _children = Children.toArray(children);

  const renderedElements = _children.map((value) => {
    const clonedChild = React.cloneElement(value, {
      url: localUrl,
    });
    return clonedChild;
  });

  return <>{renderedElements}</>;
}
